// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrContainer_xOYDD {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.loader__YBYa {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate_fXAjb 1s linear infinite
}
.loader__YBYa::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid var(--_10a37f-background);
  animation: prixClipFix_kLmeM 2s linear infinite;
}

@keyframes rotate_fXAjb {
  100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix_kLmeM {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
}

.inputContainer_UQsbK {
  background-color: var(--f5-background);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-radius: 4px;
  padding: 0px 18px;
  font-family: "Inter", sans-serif;
  margin-bottom: 18px;
}

.inputNameDevice_a9ISR {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 32px;
  color: #1e0045;
  font-weight: 300;
  padding: 0px;
  font-size: 13px;
  outline: none;
  &::placeholder {
    color: var(--_71717a-color);
  }
}

.buttonNameDevice_uNpUT {
  background-color: var(--_10a37f-background);
  color: var(--white-background);
  border: none;
  height: 32px;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 300;
  outline: none;
  &:hover {
    background-color: var(--_10a37f-background);
  }
}

.buttonNameDevice_uNpUT:disabled {
  background-color: #69d3b9;
  cursor: not-allowed;
}

.formContent_bEfy2 {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/AutomatesComponentIn/AutomatesComponentIn.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,2CAA2C;EAC3C,+CAA0C;AAC5C;;AAEA;EACE,QAAQ,yBAAyB;AACnC;;AAEA;IACI,MAAM,8CAA8C;IACpD,MAAM,0DAA0D;IAChE,MAAM,mEAAmE;IACzE,MAAM,6DAA6D;IACnE,MAAM,0DAA0D;AACpE;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".qrContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n.loader::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid var(--_10a37f-background);\n  animation: prixClipFix 2s linear infinite ;\n}\n\n@keyframes rotate {\n  100%   {transform: rotate(360deg)}\n}\n\n@keyframes prixClipFix {\n    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\n    25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\n    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\n    75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\n    100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\n}\n\n.inputContainer {\n  background-color: var(--f5-background);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  border-radius: 4px;\n  padding: 0px 18px;\n  font-family: \"Inter\", sans-serif;\n  margin-bottom: 18px;\n}\n\n.inputNameDevice {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n  height: 32px;\n  color: #1e0045;\n  font-weight: 300;\n  padding: 0px;\n  font-size: 13px;\n  outline: none;\n  &::placeholder {\n    color: var(--_71717a-color);\n  }\n}\n\n.buttonNameDevice {\n  background-color: var(--_10a37f-background);\n  color: var(--white-background);\n  border: none;\n  height: 32px;\n  width: 100%;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  outline: none;\n  &:hover {\n    background-color: var(--_10a37f-background);\n  }\n}\n\n.buttonNameDevice:disabled {\n  background-color: #69d3b9;\n  cursor: not-allowed;\n}\n\n.formContent {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qrContainer": `qrContainer_xOYDD`,
	"loader": `loader__YBYa`,
	"rotate": `rotate_fXAjb`,
	"prixClipFix": `prixClipFix_kLmeM`,
	"inputContainer": `inputContainer_UQsbK`,
	"inputNameDevice": `inputNameDevice_a9ISR`,
	"buttonNameDevice": `buttonNameDevice_uNpUT`,
	"formContent": `formContent_bEfy2`
};
export default ___CSS_LOADER_EXPORT___;
